<script setup lang="ts">
    import { IWidget } from '@/js/services/api/widget/types';
    import { Chart } from 'highcharts-vue';
    import Highcharts from 'highcharts';
    import { onMounted, ref } from 'vue';

    const props = defineProps<{
        widget: IWidget<'StaticGraph'>;
    }>();

    const options = ref<Highcharts.Options | null>(null);

    onMounted(async () => {
        try {
            options.value = JSON.parse(
                props.widget.staticGraphWidget.graphData
            ) as Highcharts.Options;
        } catch (error) {
            options.value = props.widget.staticGraphWidget.graphData as Highcharts.Options;
        }
    });
</script>
<template>
    <Chart v-if="options" :options="options" :highcharts="Highcharts" class="h-full" />
</template>
